import React from 'react';
import { ImageList, ImageListItem } from '@mui/material';
import ckDP from '../Assets/Images/ck31.jpg';

const Photo = () => {
  return (
    <ImageList
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        my: '20px',
      }}
    >
      <ImageListItem
        sx={{
          height: '100%',
          width: '100%',
          objectFit: 'contain',
        }}
      >
        <img src={ckDP} alt='dp' loading='lazy' />
      </ImageListItem>
    </ImageList>
  );
};

export default Photo;
